// extracted by mini-css-extract-plugin
export var container = "note-module--container--e729a";
export var tip = "note-module--tip--bef87";
export var title = "note-module--title--983bc";
export var warning = "note-module--warning--a874f";